const Footerbar = () => {
   return (
      <footer className="main-footer small">
         <strong>Copyright © {new Date().getFullYear()}-2021 <a href="https://renzo.pe" target="_blank">SISWEB for EsSalud</a>.</strong>
         <div className="float-right d-none d-sm-inline-block">            <b>Sisweb</b> 3.0 
         </div>
      </footer>
   )
}
export default Footerbar